export enum AdminRoutingId {
    Dashboard = "DASHBOARD",
    ApiKeyManagement = "API_KEY_MANAGEMENT",
    DealSearch = "DEAL_SEARCH",
    StoreManagement = "STORE_MANAGEMENT",
    GettingStarted = "GETTING_STARTED",
    KeywordManagement = "KEYWORD_MANAGEMENT",
    Product = "PRODUCT",
    Tasks = "TASKS",
    Users = "USERS"
}
